import { render, staticRenderFns } from "./BCardActions.vue?vue&type=template&id=3ffebf2d&scoped=true"
import script from "./BCardActions.vue?vue&type=script&lang=js"
export * from "./BCardActions.vue?vue&type=script&lang=js"
import style0 from "./BCardActions.vue?vue&type=style&index=0&id=3ffebf2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffebf2d",
  null
  
)

export default component.exports